import { render, staticRenderFns } from "./ClassificationBox.vue?vue&type=template&id=7169cb26&scoped=true"
import script from "./ClassificationBox.vue?vue&type=script&lang=js"
export * from "./ClassificationBox.vue?vue&type=script&lang=js"
import style0 from "./ClassificationBox.vue?vue&type=style&index=0&id=7169cb26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7169cb26",
  null
  
)

export default component.exports